export default "__VITE_ASSET__CmVbXFCl__"